import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=3133fe6c"
import script from "./PermissionManager.vue?vue&type=script&lang=js"
export * from "./PermissionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports